import * as types from "../actions/ActionTypes";
import { getErrorResponseForLinkedUsers } from "../utilities/ErrorMessageHelper";

export const getInitialState = () => (
    {
        linkedUsers: [],
        impersonateError: ""
    });

const siteSetupReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_LINKED_USERS_SUCCEEDED: {
        return Object.assign({}, state, { linkedUsers: action.users });
    }
    case types.LINK_USER_TO_SITE_SUCCEEDED: {
        return Object.assign({}, state, { impersonateError: "" });
    }
    case types.LINK_USER_TO_SITE_FAILED: {
        const errorMessage = getErrorResponseForLinkedUsers(action.error);
        return Object.assign({}, state, { impersonateError: errorMessage });
    }
    case types.GET_ORGANIZATION_SETTINGS_BY_ID_FAILED:
        return Object.assign({}, state, { impersonateError: action.error });
    case types.CLEAR_ERROR_MESSAGE:
        return Object.assign({}, state, { impersonateError: "" });
    default:
        return state;
    }
};


export default siteSetupReducer;
